<template>
  <div>
    <mu-dialog
      title="公众号授权"
      width="500"
      :open="open"
      @close="close"
      class="mp-dialog"
    >
      <div class="qrcode-wrapper">
        <img
          :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${user.qrimgTicket}`"
        />
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import io from 'socket.io-client'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    user: {
      type: Object
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    },
    wsInit() {
      const socket = io()
      socket.on('connect', () => {
        socket.emit('login', {
          socketId: socket.id,
          userId: this.user.id
        })
        socket.on('auth', (data) => {
          if (data.statusCode === 200) {
            this.$toast.success('授权成功')
            this.close()
          }
        })
      })
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.$nextTick(() => {
          this.wsInit()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mp-dialog {
  .qrcode-wrapper {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/mp.vue